module.exports = __webpack_public_path__ + "img/offer-annual.e0cf080d.png";